import { render, staticRenderFns } from "./grnfiledetails.vue?vue&type=template&id=6de25572"
import script from "./grnfiledetails.vue?vue&type=script&lang=js"
export * from "./grnfiledetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports